import React, { Component } from "react"
import { connect } from "react-redux"
import { translate } from "react-translate"
import { Link } from "react-router-dom"
import { fileText2 as devisIcon } from "react-icons-kit/icomoon/fileText2"

import {
  Segment,
  Grid,
  Image,
  Header,
  Icon,
  Modal,
  Button,
  Container,
  Item,
  Divider
} from "semantic-ui-react"
import "./ProAccueilComponent.css"
import CardOverview from "./CardOverview"
import CardAccueil from "./CardAcceuil"
import _ from "lodash"

import illustration from '../../../assets/pro/illustration.png';


const acceuilDatas = [
  {
    titre: "title_devis_modifié",

    prestations: [
      {
        nameCustomer: "Jeremy Hicks",
        namePrestations: "Isolation thermique",
        price: "3728€"
      },
      {
        nameCustomer: "Florence Ruiz",
        namePrestations: "Extension, agrandissement",
        price: "3233€"
      },
      {
        nameCustomer: "Devin Gill",
        namePrestations: "Rénovation maison",
        price: "4933€"
      }
    ]
  },
  {
    titre: "title_factures_modifié",

    prestations: [
      {
        nameCustomer: "Ora Mitchell",
        namePrestations: "Surélévation maison",
        price: "1872€"
      },
      {
        nameCustomer: "Chad Fletcher",
        namePrestations: "Chauffage",
        price: "800€"
      }
    ]
  }
]

const mapStateToProps = state => ({
  app: state.app
})

class ConnectedProAccueilComponent extends Component {
  constructor(props) {
    super(props)

    this.state = {}
  }

  componentWillMount() {}

  render() {
    let { t } = this.props
    return (
      <Segment id="proAccueil">
        {" "}
        <Container id="border">
          <Grid columns={2}>
            <Grid.Row>
              <Grid.Column verticalAlign="middle" mobile={4} tablet={5} computer={6}>
                <Image
                  src={illustration}
                  id="man"
                  alt="manOnDesk"
                />
              </Grid.Column>
              <Grid.Column verticalAlign="middle" id="textParagraph" mobile={12} tablet={11} computer={10}>
                <Container id="columnCenteredContent">
                  <Container id="helloText">
                    {t("name_user_hello")} <br />
                    {t("welcome_user")}
                  </Container>
                  <Button class="ui green button" id="addBtn">
                    <Icon
                      className="add"
                      id="iconDisplayAdd"
                      color="green"
                      name="add"
                      circular
                      bordered
                    />
                    {t("button_home_create")}
                  </Button>
                </Container>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Container>
        <h3 id="otherTitle">{t("overview_home")}</h3>
        <Grid columns={2} id="cardGrid">
          <Grid.Row divided className="cardRow">
            {_.map(acceuilDatas, acceuilData => {
              return (
                <Grid.Column className="cardCol">
                  <CardOverview
                    titre={t(acceuilData.titre)}
                    prestations={acceuilData.prestations}
                    icon={devisIcon}
                  />
                </Grid.Column>
              )
            })}
          </Grid.Row>

          <Grid.Row divided className="cardRow">
            <Grid.Column className="cardCol">
              <CardAccueil
                titre={t("label_devis_waiting")}
                description={t("description_devis_waiting_home")}
                rules={t("rules_devis_waiting_home")}
              />
            </Grid.Column>

            <Grid.Column className="cardCol">
              <CardAccueil
                titre={t("label_factures_waiting")}
                description={t("description_factures_waiting_home")}
              />
            </Grid.Column>
          </Grid.Row>

          {/* <Grid.Column>
            <CardAccueil
              titre={t("label_devis_waiting")}
              description={t("description_devis_waiting_home")}
              rules={t("rules_devis_waiting_home")}
            />
          </Grid.Column>
          <Grid.Column>
            <CardAccueil
              titre={t("label_factures_waiting")}
              description={t("description_factures_waiting_home")}
            />
          </Grid.Column> */}
        </Grid>
      </Segment>
    )
  }
}

const ProAccueilComponent = connect(mapStateToProps)(
  ConnectedProAccueilComponent
)
export default translate("ProAccueilComponent")(ProAccueilComponent)



// WEBPACK FOOTER //
// ./src/components/Pro/Accueil/ProAccueilComponent.jsx